import { render, staticRenderFns } from "./ButtonAssignmentRemove.vue?vue&type=template&id=3eb838ea&scoped=true&"
import script from "./ButtonAssignmentRemove.vue?vue&type=script&lang=js&"
export * from "./ButtonAssignmentRemove.vue?vue&type=script&lang=js&"
import style1 from "./ButtonAssignmentRemove.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb838ea",
  null
  
)

export default component.exports